module.exports = [
  require('./war_priest'),
  require('./warlock_of_the_archfey'),
  require('./warlock_of_the_fiend'),
  require('./warlock_of_the_great_old_one'),
  require('./warlord'),
  require('./wood_woad'),
]
